import { AnalyticsStore } from 'bernie-plugin-mobx';
import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { UiStore } from 'stores';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

// Utils
import analyticsUtil from '../util/analytics-util';
import { pageNames } from '../data/page-names';

export class UserProfileController implements Controller {
  public pageId = pageNames.userProfile;
  public path = '/:localeName/user-profile';
  public routeName = 'userProfile';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "user-profile-page" */ '../views/user-profile-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');
    const context = request.context;

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve({});
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub User Profile' }) as Promise<PageData>;
  }
}
